/**
 * Shared "is this file load a failure" logic for the File Loader dashboard.
 *
 * The backend job status is only ever 'success' or 'failed' at the job level. A
 * file can load 'success' yet have every data row rejected during validation
 * (rowsAccepted === 0, rowsRejected > 0). Those files must still read as failures
 * on the dashboard, so the summary card, the table status and the grouped list
 * all share this single definition rather than each rolling their own and drifting
 * apart (which is exactly what caused the "Failed Files: 0" vs table mismatch).
 */

/** True when the load job itself did not succeed. Case-insensitive. */
export function jobFailed (job) {
  const status = job.loadStatus == null ? '' : String(job.loadStatus).toLowerCase()
  return status !== 'success'
}

/** True when the job ran but every row was rejected (nothing accepted). */
export function allRowsRejected (job) {
  // Coerce defensively: these are typed as numbers but the API has been seen to
  // return numeric strings. Strict `=== 0` (not `|| 0`) so only an explicit zero
  // accepted count counts as "all rejected", never missing/NaN data.
  return Number(job.rowsRejected) > 0 && Number(job.rowsAccepted) === 0
}

/** True when the file should be surfaced as a failure on the dashboard. */
export function isFailedFile (job) {
  return jobFailed(job) || allRowsRejected(job)
}
